// ###################################
// seed 문자열을 시드로 한 결정론적 셔플 (Fisher-Yates + LCG)
// - 같은 seed면 항상 같은 결과 (workbookKey 등으로 일관된 보기 순서 보장)
// ###################################
export const shuffleArrayWithSeed = <T>(array: T[], seed: string): T[] => {
  // FNV-1a: 비슷한 문자열(number-1, number-2 등)도 서로 다른 32bit seed로 섞는다.
  const hashCode = (str: string): number => {
    let hash = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
      hash ^= str.charCodeAt(i);
      hash = Math.imul(hash, 0x01000193);
    }
    return hash >>> 0;
  };

  // Seeded Random Number Generator (LCG 알고리즘)
  const seededRandom = (seed: number): (() => number) => {
    let value = seed;
    return () => {
      value = (value * 1664525 + 1013904223) % 4294967296;
      return value / 4294967296;
    };
  };

  const shuffled = [...array];
  const random = seededRandom(hashCode(seed));
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// 동일 permutation을 여러 배열에 적용할 때 사용 (예: choice + choicePronunciation)
export const shuffleIndicesWithSeed = (length: number, seed: string): number[] => {
  return shuffleArrayWithSeed(
    Array.from({ length }, (_, i) => i),
    seed,
  );
};
